<template>
<div>
	<v-layout wrap align-center class="mb-10 py-5">
		<v-flex md6 lg7>
			<h1 class="display-2 mb-3">{{ trans('app.preferences_register_title') }}</h1>
			<p class="subtitle-1">{{ trans('app.preferences_register_subtitle') }}</p>
		</v-flex>
		<v-flex md6 lg5>
			<v-card>
				<slot></slot>
			</v-card>
		</v-flex>
	</v-layout>

	<v-layout wrap class="mb-10">
		<v-flex xs12>
			<v-container fluid grid-list-lg class="px-0">
				<v-layout>

					<v-flex sm4 v-for="benefit,i in benefits" :key="i">
						<v-card class="h-100 elevation-1">
							<v-card-title>
								<v-avatar color="primary">
									<v-icon dark>{{ benefit.icon }}</v-icon>
								</v-avatar>
								<h3 class="my-3">{{ trans(benefit.title) }}</h3>
							</v-card-title>
							<v-card-text>{{ trans(benefit.description) }}</v-card-text>
						</v-card>
					</v-flex>
					
				</v-layout>
			</v-container>
		</v-flex>
	</v-layout>


	<h2 class="display-2 text-center">{{ trans('app.preferences_register_howto_title') }}</h2>

	<v-container grid-list-lg class="px-0">

		<v-row class="mb-5" justify="center" v-for="step,i in steps" :key="i">
			<v-col sm="12" md="8">
				<v-layout wrap align-center class="mb-5">
					<v-flex md6 :order-md1="(i % 2) ? 1 : 0">
						<h3 class="mb-3">{{ trans(step.title) }}</h3>
						<p>{{ trans(step.description) }}</p>
					</v-flex>
					<v-flex md6>
						<v-img 
						aspect-ratio="1" 
						:src="step.image"></v-img>
					</v-flex>
				</v-layout>
			</v-col>
		</v-row>
		
	</v-container>
</div>
</template>

<script>
export default {
	data: () => ({
		benefits: [
			{
				title: 'app.preferences_benefit_1_title',
				description: 'app.preferences_benefit_1_description',
				icon: 'mdi-alarm-check',
			},
			{
				title: 'app.preferences_benefit_2_title',
				description: 'app.preferences_benefit_2_description',
				icon: 'mdi-account-search',
			},
			{
				title: 'app.preferences_benefit_3_title',
				description: 'app.preferences_benefit_3_description',
				icon: 'mdi-magnify',
			},
		],
		steps: [
			{
				title: 'app.preferences_howto_1_title',
				description: 'app.preferences_howto_1_description',
				image: 'https://picsum.photos/640/640?random=1',
			},
			{
				title: 'app.preferences_howto_2_title',
				description: 'app.preferences_howto_2_description',
				image: 'https://picsum.photos/640/640?random=2',
			},
			{
				title: 'app.preferences_howto_3_title',
				description: 'app.preferences_howto_3_description',
				image: 'https://picsum.photos/640/640?random=3',
			},
		]
	})
}
</script>
